import { render, staticRenderFns } from "./ChartCaruselBlock.vue?vue&type=template&id=31183225&scoped=true&"
import script from "./ChartCaruselBlock.vue?vue&type=script&lang=js&"
export * from "./ChartCaruselBlock.vue?vue&type=script&lang=js&"
import style0 from "./ChartCaruselBlock.vue?vue&type=style&index=0&id=31183225&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31183225",
  null
  
)

export default component.exports